export default {
  booking: () => import("/Users/olivermurphy/Code/spas/justhire/layouts/booking.vue"),
  default: () => import("/Users/olivermurphy/Code/spas/justhire/layouts/default.vue"),
  "transparent-nav": () => import("/Users/olivermurphy/Code/spas/justhire/layouts/transparent-nav.vue")
}